import React from "react";

export const EditIcon = ({width = '18', height = '18'}) => {
    return (
        <div className={'context-icon-wrapper'}  style={{width: `${width}px`, height: `${height}px`}}>
            <svg width={width} height={height} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15.4799 1.85464C14.9222 1.29748 14.0184 1.29738 13.4608 1.85464L4.2608 11.0546C4.08983 11.2257 3.96506 11.4375 3.89827 11.6699L2.82449 15.4091C2.51519 16.4874 3.51263 17.4847 4.59087 17.1755L8.33011 16.1017C8.56259 16.0349 8.7743 15.9102 8.94538 15.7392L18.1454 6.53922C18.7027 5.98156 18.7027 5.07776 18.1454 4.5201L15.4799 1.85464ZM17.2615 5.40399C17.3306 5.47349 17.3306 5.58583 17.2615 5.65534L8.06149 14.8553C8.04018 14.8766 8.01376 14.8919 7.98485 14.9002L4.24629 15.9747C4.1119 16.013 3.98688 15.8881 4.02532 15.7537L5.09979 12.0152C5.10811 11.9863 5.12348 11.9598 5.14468 11.9385L14.3447 2.73852C14.4141 2.66942 14.5265 2.66952 14.596 2.73852L17.2615 5.40399Z"
                    fill="#222222"/>
            </svg>
        </div>

    );
}